import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const MapViewContext = createContext({});

export const useMapViewContext = () => {
  return useContext(MapViewContext);
};

export const MapViewContextProvicer = ({ children, value }) => {
  return <MapViewContext.Provider value={value}>{children}</MapViewContext.Provider>;
};
